import React, { useState } from "react";
import "./Header.css";
import MenuImg from "../../assets/images/Menu.png";
import 'rc-menu/assets/index.css';
import Menu, {SubMenu, MenuItem } from 'rc-menu';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleNavigationClick = (info: any) => {
    window.location.href = info.key;
  };

  return (
    <header className="header">
      <div className="left-section">
        <div className="logo">
          <a href="https://claya.com">
            <img src="/images/clogo.png" alt="Claya Logo"/>
          </a>
        </div>
      </div>
      <nav className="menu">
        <div className="menu-left">
          <Menu mode="horizontal"
                onClick={handleNavigationClick}>
            <SubMenu title="Treatments"
                     key="https://claya.com/weight-loss/"
                     onTitleClick={handleNavigationClick}>
              <SubMenu title="Semaglutide"
                       key="https://claya.com/weight-loss/semaglutide/"
                       onTitleClick={handleNavigationClick}>
                <MenuItem key="https://claya.com/weight-loss/semaglutide-injectables/">Semaglutide Injectables</MenuItem>
                <MenuItem key="https://claya.com/weight-loss/semaglutide-tablets/">Semaglutide Tablets</MenuItem>
                <MenuItem key="https://claya.com/weight-loss/ozempic/">Ozempic</MenuItem>
              </SubMenu>
              <SubMenu title="Tirzepatide"
                       key="https://claya.com/weight-loss/tirzepatide/"
                       onTitleClick={handleNavigationClick}>
                <MenuItem key="https://claya.com/weight-loss/tirzepatide-injectables/">Tirzepatide Injectables</MenuItem>
                <MenuItem key="https://claya.com/weight-loss/tirzepatide-tablets/">Tirzepatide Tablets</MenuItem>
                <MenuItem key="https://claya.com/weight-loss/zepbound/">Zepbound</MenuItem>
                <MenuItem key="https://claya.com/weight-loss/mounjaro/">Mounjaro</MenuItem>
              </SubMenu>
              <MenuItem key="https://claya.com/weight-loss/membership/">Weight Loss Membership</MenuItem>
              <MenuItem key="https://claya.com/wellness-coaching/">Wellness Coaching</MenuItem>
            </SubMenu>
            <SubMenu title="Our approach"
                     key="https://claya.com/our-approach/"
                     onTitleClick={handleNavigationClick}>
              <MenuItem key="https://claya.com/our-medical-experts/">Care Team</MenuItem>
              <MenuItem key="https://claya.com/member-success-stories/">Member success stories</MenuItem>
            </SubMenu>
            <SubMenu title="Learning"
                     key="https://claya.com/learning/"
                     onTitleClick={handleNavigationClick}>
              <MenuItem key="https://claya.com/learning/weight-loss-and-management/">Weight Loss and Management</MenuItem>
              <MenuItem key="https://claya.com/learning/holistic-health-and-wellness/">Holistic Health and Wellness</MenuItem>
              <MenuItem key="https://claya.com/learning/glp-1-and-medical-science/">GLP-1 and Medical Science</MenuItem>
              <MenuItem key="https://claya.com/learning/nutrition-and-healthy-eating/">Nutrition and Healthy Eating</MenuItem>
              <MenuItem key="https://claya.com/learning/exercise-and-physical-activity/">Exercise and Physical Activity</MenuItem>
              <MenuItem key="https://claya.com/learning/mental-health-and-motivation/">Mental Health and Motivation</MenuItem>
            </SubMenu>
            <MenuItem key="https://claya.com/weight-loss/for-providers/">For providers</MenuItem>
            <MenuItem key="https://claya.com/contact-us/">Connect</MenuItem>
          </Menu>
        </div>
        <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
          <Menu mode="vertical"
                onClick={handleNavigationClick}>
            <MenuItem key="https://questionnaire.claya.com/form/step/1/?_gl=1*1y85o17*_ga*MTQ5NTc0ODkwOC4xNzM1ODQ1ODE3*_ga_Y22MRFVTS5*MTczNjI2NDkyNy40LjAuMTczNjI2NDkyNy4wLjAuMA"
                      className="cta-menu-item">Get started</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/"
                      className="title-menu-item">Treatments</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/semaglutide/"
                      className="sub1-menu-item">Semaglutide</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/semaglutide-injectables/"
                      className="sub2-menu-item">Semaglutide Injectables</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/semaglutide-tablets/"
                      className="sub2-menu-item">Semaglutide Tablets</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/ozempic/"
                      className="sub2-menu-item">Ozempic</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/tirzepatide/"
                      className="sub1-menu-item">Tirzepatide</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/tirzepatide-injectables/"
                      className="sub2-menu-item">Tirzepatide Injectables</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/tirzepatide-tablets/"
                      className="sub2-menu-item">Tirzepatide Tablets</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/zepbound/"
                      className="sub2-menu-item">Zepbound</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/mounjaro/"
                      className="sub2-menu-item">Mounjaro</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/membership/"
                      className="sub1-menu-item top-level-menu-item">Weight Loss Membership</MenuItem>
            <MenuItem key="https://claya.com/wellness-coaching/"
                      className="sub1-menu-item top-level-menu-item">Wellness Coaching</MenuItem>
            <MenuItem key="https://claya.com/our-approach/"
                      className="title-menu-item">Our approach</MenuItem>
            <MenuItem key="https://claya.com/our-medical-experts/"
                      className="sub1-menu-item">Care Team</MenuItem>
            <MenuItem key="https://claya.com/member-success-stories/"
                      className="sub1-menu-item">Member success stories</MenuItem>
            <MenuItem key="https://claya.com/learning/"
                      className="title-menu-item">Learning</MenuItem>
            <MenuItem key="https://claya.com/learning/weight-loss-and-management/"
                      className="sub1-menu-item">Weight Loss and Management</MenuItem>
            <MenuItem key="https://claya.com/learning/holistic-health-and-wellness/"
                      className="sub1-menu-item">Holistic Health and Wellness</MenuItem>
            <MenuItem key="https://claya.com/learning/glp-1-and-medical-science/"
                      className="sub1-menu-item">GLP-1 and Medical Science</MenuItem>
            <MenuItem key="https://claya.com/learning/nutrition-and-healthy-eating/"
                      className="sub1-menu-item">Nutrition and Healthy Eating</MenuItem>
            <MenuItem key="https://claya.com/learning/exercise-and-physical-activity/"
                      className="sub1-menu-item">Exercise and Physical Activity</MenuItem>
            <MenuItem key="https://claya.com/learning/mental-health-and-motivation/"
                      className="sub1-menu-item">Mental Health and Motivation</MenuItem>
            <MenuItem key="https://claya.com/weight-loss/for-providers/"
                      className="top-level-menu-item">For providers</MenuItem>
            <MenuItem key="https://claya.com/contact-us/"
                      className="top-level-menu-item">Connect</MenuItem>
          </Menu>
        </div>
      </nav>
      <div className="menu-right">
        <div className="hamburger" onClick={toggleMenu}>
          <img src={MenuImg} alt="Menu" className="menu-icon"/>
        </div>
        <button className="get-started-btn"
                onClick={() => window.location.href = "https://questionnaire.claya.com/form/step/1/?_gl=1*1y85o17*_ga*MTQ5NTc0ODkwOC4xNzM1ODQ1ODE3*_ga_Y22MRFVTS5*MTczNjI2NDkyNy40LjAuMTczNjI2NDkyNy4wLjAuMA"}>Get
          Started
        </button>
      </div>
    </header>
  );
};

export default Header;
